import BackendService from "../../../backend/controller/BackendService";
import LlmConversationMessage, { LlmMessageSender } from "../../../conversation/model/LlmConversationMessage";
import PlayerModel from "../../../player/model/PlayerModel";
import ConversationReflection from "../../model/ConversationReflection";
import ConversationReflectionMessage, { ReflectionMessageSender } from "../../model/ConversationReflectionMessage";
import ConversationReflectionState from "./ConversationReflectionState";
import PlayerTurnConversationReflectionState from "./PlayerTurnConversationReflectionState";

export default class StartingTurnConversationReflectionState extends ConversationReflectionState {
    /**
     * 
     * @param {string} chapterId
     * @param {ConversationReflection} conversation 
     * @param {BackendService} backendService 
     * @param {PlayerModel} playerModel
     * @returns {Promise<ConversationReflectionState>}
     */
    async execute(chapterId, conversation, backendService, playerModel) {
        try {
            const conversationReflectionResponse = await backendService.conversationReflection({
                chapterId: chapterId,
                conversationId: conversation.id,
                conversationHistory: conversation.conversationHistoryForLLM,
                playerName: playerModel.getTrimmedPlayerName(),
            });

            conversation.addConversationHistory({
                llmConversationMessages: [new LlmConversationMessage(LlmMessageSender.ASSISTANT, conversationReflectionResponse.message)],
                gameConversationMessages: [new ConversationReflectionMessage(ReflectionMessageSender.COACH, conversationReflectionResponse.message)],
            });
        } catch (error) {
            console.error(`[${StartingTurnConversationReflectionState.name}] execute error: `, error);
            return Promise.reject(error);
        }

        const nextState = new PlayerTurnConversationReflectionState();
        return Promise.resolve(nextState);
    }
}